import Snackbar from '@material-ui/core/Snackbar';
import {removeSnackbar} from 'Core/ducks/snackbar';
import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {Alert} from '@material-ui/lab';
import './Notifications.sass';

const Notifications = () => {
  const dispatch = useDispatch();

  const {messages} = useSelector((state: ReducerState) => state.snackbar);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
  }, []);

  const handleCloseCurried = (id: string) => (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);

    dispatch(removeSnackbar(id));
  };

  return (
    <>
      {messages.map(message => {
        const {useAlert, description, id} = message;

        const handleClose = handleCloseCurried(id);

        return useAlert! ? (
          <Snackbar
            key={`snackbar_${id}`}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={open}
            onClose={handleClose}
            message={description}
          >
            <Alert icon={false} onClose={handleClose}>
              {description}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={`snackbar_${id}`}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open
            autoHideDuration={5 * 1000}
            onClose={() => dispatch(removeSnackbar(id))}
            message={description}
          />
        );
      })}
    </>
  );
};

export default Notifications;
